import { connect } from "react-redux";
import { ActionPromises } from "../state/actionPromises";
import { CurrencySelector as CurrencySelectorComponent } from "@travellocal/ui";

interface OwnProps {
  closeOnMenuClose?: boolean;
  onSelect?: (currency: IBaseCurrency) => void;
}

interface StateProps {
  currency: IBaseCurrency;
  currencies: IBaseCurrency[];
}

interface DispatchProps {
  onSelect: (currency: IBaseCurrency) => void;
}

type Props = OwnProps & StateProps & DispatchProps;

interface State {
  visible?: boolean;
}

const stateToProps = (state: IWebStoreState, ownProps: OwnProps): StateProps => {
  return {
    currency: state.currency?.data,
    currencies: state.currencies?.data,
  };
};

const dispatchToProps = (dispatch): DispatchProps => {
  return {
    onSelect: (currency: IBaseCurrency) => dispatch(ActionPromises.changeCurrency(currency)),
  };
};

export const CurrencySelector = connect(stateToProps, dispatchToProps)(CurrencySelectorComponent);
